import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WorkstationLine } from '../models/workstationline';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class WorkstationService extends BaseService {
  private lines: WorkstationLine[] = [];
  private item: any;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  initializeLines(item: any, itemId: string): void {
    this.item = item;
    this.item.workstationlines = [];
    this.lines = [];
    if (itemId === 'new') {
      this.addLine(null);
    }
  }

  loadInitialLines(itemId: string): void {
    if (itemId !== 'new') {
      this.getSavedLines(itemId)
        .pipe(take(1))
        .subscribe((res) => {
          this.lines = res;
          this.item.workstationlines = res;
          console.log('lines', this.lines);
          this.addLine(null);
          this.refresh();
        });
    }
  }

  getSavedLines(entdataId: string): Observable<WorkstationLine[]> {
    return this.get<WorkstationLine[]>(
      this.apiUrl + 'workstationlines/' + entdataId
    );
  }

  updateWorkingStatus(line: WorkstationLine): void {
    const timestamp = new Date().toISOString();
    const payload = {
      workstation_id: line.workstation_id,
      working: line.working,
      timestamp: timestamp,
      entdata_id: line.entdata_id,
      minutes: line.minutes,
    };

    this.post<any>(this.apiUrl + 'workstationlines/timestamp', payload)
      .pipe(take(1))
      .subscribe();
  }

  removeLine(index: number): void {
    this.lines.splice(index, 1);
    this.refresh();
  }

  fillWorkstationLine(item: any, line: WorkstationLine): void {
    line.workstation = item;
    line.workstation_id = item.id;
    this.addLine(null);
  }

  addLine(item: any): void {
    let newLine: WorkstationLine = new WorkstationLine();
    newLine.workstation = item;
    newLine.minutes = 1;
    newLine.workstation_id = item?.id ?? null;
    newLine.working = null;
    this.lines.push(newLine);
    this.refresh();
  }

  getLines(): WorkstationLine[] {
    return this.lines;
  }

  private refresh(): void {
    this.item.workstationlines = this.lines.filter((x) => x.workstation);
  }
}
